// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"2":"6f7badbd","72":"9305e070","690":"a7558cbc"}[chunkId] + ".chunk.css");